import { Tooltip } from '@wapharma/design-system';
import { formatCountdownFriendlyFr, formatFriendlyDate } from '../utils/friendlyDate';
import styles from './FriendlyDate.module.css';

type FriendlyDateProps = {
  iso: string | null | undefined;
  /**
   * `relative` — past / near-future (“il y a…”, calendar beyond ~60j).
   * `countdown` — expiry-style (“dans 3 jours…”) for validité / DLC.
   */
  variant?: 'relative' | 'countdown';
};

/** Relative French label; hover shows full date/time. */
export function FriendlyDate({ iso, variant = 'relative' }: FriendlyDateProps) {
  const { text, detail } =
    variant === 'countdown' ? formatCountdownFriendlyFr(iso) : formatFriendlyDate(iso);
  if (!detail) return <>{text}</>;
  const noWrapLabel = detail.replace(/ /g, '\u00A0');
  return (
    <Tooltip label={noWrapLabel} portal position="bottom">
      <span className={styles.linkish} tabIndex={0}>
        {text}
      </span>
    </Tooltip>
  );
}
